import { render, staticRenderFns } from "./SurveyDialog.vue?vue&type=template&id=afb53762&scoped=true"
import script from "./SurveyDialog.vue?vue&type=script&lang=js"
export * from "./SurveyDialog.vue?vue&type=script&lang=js"
import style0 from "./SurveyDialog.vue?vue&type=style&index=0&id=afb53762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb53762",
  null
  
)

export default component.exports